class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    // $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    // $("." + this.el).on('click', function() {
    //   $(this).toggleClass('is-active');
    //   $(this).parent().parent().parent().next().slideToggle();
    // })
    $(function(){
      //クリックで動く
      $('.accTrigger').click(function(){
        if($(this).hasClass('is-open')){
          $(this).toggleClass('is-open');
          $(this).next('.accBody').slideToggle();
        } else {
          $(this).toggleClass('is-open');
          $(this).next('.accBody').slideToggle();
        }
      });
    });
  }
}